import ADD_PRODUCT_EVENT from 'api/mutations/ADD_PRODUCT_EVENT';
import REMOVE_PRODUCT_EVENT from 'api/mutations/REMOVE_PRODUCT_EVENT';
import UPDATE_PRODUCT_EVENT from 'api/mutations/UPDATE_PRODUCT_EVENT';
import GET_PRODUCT_EVENTS from 'api/queries/GET_PRODUCT_EVENTS';
import { createProductParameterSlice } from './createProductParameterSlice';
const productEventsSlice = createProductParameterSlice({
    name: 'productEvents',
    stateKey: 'productEvents',
    query: GET_PRODUCT_EVENTS,
    addMutation: ADD_PRODUCT_EVENT,
    updateMutation: UPDATE_PRODUCT_EVENT,
    removeMutation: REMOVE_PRODUCT_EVENT,
    idVariableName: 'productEventId',
    selectConnection: (data) => data.autocomplete.productEvents,
    selectAddedItem: (data) => data.addProductEvent.productEvent,
    selectUpdatedItem: (data) => data.updateProductEvent.productEvent,
});
export const resetProductEvents = productEventsSlice.reset;
export const fetchProductEvents = productEventsSlice.fetchItems;
export const addProductEvent = productEventsSlice.addItem;
export const updateProductEvent = productEventsSlice.updateItem;
export const removeProductEvent = productEventsSlice.removeItem;
export const selectProductEvents = productEventsSlice.selectItems;
export const selectProductEventById = productEventsSlice.selectItemById;
export const selectProductEventsPageInfo = productEventsSlice.selectPageInfo;
export const selectProductEventsStatus = productEventsSlice.selectStatus;
export const selectProductEventsErrors = productEventsSlice.selectErrors;
export const selectProductEventsRefetchFlags = productEventsSlice.selectRefetchFlags;
export default productEventsSlice.reducer;
